import React, { useState, useEffect } from "react"
import { Button, Card, Form, Alert, ListGroup } from "react-bootstrap"
import { collection, doc, addDoc, getDocs } from "firebase/firestore"
import { firestore } from "../config/db"
import { fetchAdmins } from "../app/functions"
import RatingComponent from "./RatingComponent"

const usersEmails = [
  "j.skup@op.pl",
  "aleksandraprzepiorka@gmail.com",
  "sensounico@wp.pl",
  "jacek.gajewski@ncbj.gov.pl",
  "j.pogorzelski@rotary.org.pl",
  "bozenaister@gmail.com",
  "iwona.ryniak-olszanka@retermozanex.com.pl",
  "agatom@wa.onet.pl",
  "pawelek.sliwka@gmail.com",
  "marcintrzos@gmail.com",
  "aszlaska@gmail.com",
  "mareklem@op.pl",
  "marta.opacka@gmail.com",
  "jlempicki@lmsg.pl",
  "m.skup@rotary.org.pl",
  "mmhaczyk@gmail.com",
]

function Feedback({ uid }) {
  const [feedback, setFeedback] = useState("")
  const [feedbackList, setFeedbackList] = useState([])
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")
  const [nonVoters, setNonVoters] = useState([])
  const [skupScholarshipTickedBy, setSkupScholarshipTickedBy] = useState([])
  const [ratingRefreshToken, setRatingRefreshToken] = useState(0)

  useEffect(() => {
    const fetchNonVoters = async () => {
      const userDocRef = doc(firestore, `submissions/${uid}`)
      const ratingCollectionRef = collection(userDocRef, "rating")
      const querySnapshot = await getDocs(ratingCollectionRef)

      const ratingDocs = querySnapshot.docs.map((d) => d.data())

      const votedEmails = ratingDocs
        .filter(
          (data) =>
            typeof data?.rating === "number" &&
            Number.isFinite(data.rating) &&
            data.rating > 0,
        )
        .map((data) => data.adminEmail)

      const tickedBy = ratingDocs
        .filter((data) => Boolean(data?.bronislawaSkupScholarship))
        .map((data) => data.adminEmail)
        .filter(Boolean)
        .sort((a, b) => String(a).localeCompare(String(b)))

      setSkupScholarshipTickedBy(tickedBy)

      const admins = (await fetchAdmins()) || []
      const authenticatedAdminEmails = admins
        .filter((admin) => admin.authenticated === true && admin.email)
        .map((admin) => admin.email)
      const notVoted = authenticatedAdminEmails.filter(
        (email) => !votedEmails.includes(email),
      )
      setNonVoters(notVoted)
    }

    fetchNonVoters()
  }, [uid, ratingRefreshToken])

  const handleSubmit = async () => {
    setSuccess(false)
    setError("")

    if (!feedback.trim()) {
      setError("Komentarz nie może być pusty.")
      return
    }

    const user = JSON.parse(localStorage.getItem("user"))
    const adminId = user.uid
    const adminEmail = user.email

    try {
      const userDocRef = doc(firestore, `submissions/${uid}`)
      const feedbackCollectionRef = collection(userDocRef, "feedback")

      const docRef = await addDoc(feedbackCollectionRef, {
        feedback,
        adminId,
        adminEmail,
        timestamp: new Date(),
      })

      setFeedbackList((prev) => [
        ...prev,
        { id: docRef.id, feedback, adminId, adminEmail, timestamp: new Date() },
      ])
      setFeedback("")
      setSuccess(true)
      setTimeout(() => setSuccess(false), 6000)
    } catch (err) {
      console.error("Error adding feedback: ", err)
      setError("Wystąpił błąd podczas przesyłania komentarza.")
    }
  }

  return (
    <Card>
      <Card.Body>
        <RatingComponent
          uid={uid}
          setFeedbackList={setFeedbackList}
          onRatingDocChanged={() => setRatingRefreshToken((t) => t + 1)}
        />
        <hr />
        <Card.Title>Komentarze</Card.Title>
        <hr />
        {success && (
          <Alert variant="success">Komentarz został pomyślnie przesłany!</Alert>
        )}
        {error && <Alert variant="danger">{error}</Alert>}

        <Form>
          <Form.Group controlId="feedbackInput" style={{ display: "flex" }}>
            <Form.Control
              as="textarea"
              placeholder="Napisz swój komentarz..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              className="mx-1"
              style={{ resize: "none", overflow: "hidden", height: "auto" }}
            />
            <Button variant="primary" onClick={handleSubmit}>
              Wyślij
            </Button>
          </Form.Group>
        </Form>

        <hr />
        <h5>Lista Komentarzy:</h5>
        <ListGroup>
          {feedbackList.map((item) => (
            <ListGroup.Item key={item.id}>
              <strong>{item.adminEmail}</strong>{" "}
              {new Date(item.timestamp).toLocaleString()}
              <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                {item.feedback}
              </pre>
            </ListGroup.Item>
          ))}
        </ListGroup>

        <hr />
        <Card>
          <Card.Body>
            <Card.Title>Zaznaczyli: Stypendium im. Bronisławy Skup</Card.Title>
            <ListGroup>
              {skupScholarshipTickedBy.length > 0 ? (
                skupScholarshipTickedBy.map((email) => (
                  <ListGroup.Item key={email}>{email}</ListGroup.Item>
                ))
              ) : (
                <ListGroup.Item>Nikt nie zaznaczył.</ListGroup.Item>
              )}
            </ListGroup>
          </Card.Body>
        </Card>

        <hr />
        <Card>
          <Card.Body>
            <Card.Title>Brak głosu</Card.Title>
            <ListGroup>
              {nonVoters.length > 0 ? (
                nonVoters.map((email) => (
                  <ListGroup.Item key={email}>{email}</ListGroup.Item>
                ))
              ) : (
                <p>Wszyscy użytkownicy oddali głos.</p>
              )}
            </ListGroup>
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  )
}

export default Feedback
